import { useEffect, useMemo, useRef, useState } from 'react';

import { useOnClickOutside } from 'utils/hooks';
import { useMe, useOrg } from 'utils/reduxHook';
import InAppRoutes from 'utils/router';

import Icon from 'components/atoms/Icon';
import { matchPath, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { getOrgUserInitials, getUserNameOrg } from 'utils';
import UserMenuItems from './UserMenuItems';

const customBrandingRoutes = [InAppRoutes.DiscoverKit];

function UserMenu({ textColor }: { textColor?: 'black' | 'white' }) {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const me = useMe();
  const subMenuRef = useRef(null);
  const dropdownRef = useRef(null);

  useOnClickOutside([subMenuRef, dropdownRef], () => setIsSubMenuOpen(false));
  const location = useLocation();
  const branding = useSelector(({ info }: RootState) => info.branding);
  const organization = useOrg();

  useEffect(() => {
    // Close menu when navigating
    setIsSubMenuOpen(false);
  }, [location.pathname]);

  const shouldShowBranding = useMemo(
    () => !!matchPath(location.pathname, { path: customBrandingRoutes, exact: true }),
    [location.pathname],
  );

  const brandedTextColor =
    shouldShowBranding && branding?.textColor
      ? {
          color: branding.textColor,
        }
      : null;

  return (
    <div className="relative">
      <div
        ref={dropdownRef}
        className="flex flex-row h-full items-center cursor-pointer"
        onClick={() => setIsSubMenuOpen(!isSubMenuOpen)}
      >
        <div className="flex flex-row items-center" data-durable-id="navUserAccount">
          <div className="h-8 w-8 bg-charcoal-100 rounded-full flex items-center justify-center mr-2 text-xs font-medium text-charcoal-900">
            {getOrgUserInitials(me)}
          </div>
          <div className="flex flex-col">
            <div className="font-semibold text-sm text-white">{getUserNameOrg(me)}</div>
            <div className="text-xs text-charcoal-100">{organization?.name}</div>
          </div>
        </div>
        <Icon
          name={isSubMenuOpen ? 'chevron-up' : 'chevron-down'}
          size={15}
          className={`ml-4 ${textColor === 'white' ? 'text-white' : ''}`}
          style={brandedTextColor}
        />
      </div>
      {isSubMenuOpen ? (
        <div ref={subMenuRef} className="absolute right-0 z-50 pt-6 animated fadeIn animate200">
          <div className="relative py-3 bg-black  max-h-[calc(100vh_-_8rem)] overflow-y-auto" style={{ minWidth: 200 }}>
            <div className="text-white px-4 text-sm font-semibold">{getUserNameOrg(me)}</div>
            <div className="text-white px-4 text-sm pb-3 border-b border-charcoal-700">{me?.email}</div>
            <UserMenuItems onChangeRoute={() => setIsSubMenuOpen(false)} />
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default UserMenu;
